import axios from "axios";
import { useState, useEffect, useContext } from 'react';
import { AuthContext } from "../context/AuthContext";
import { AppConfigContext } from "../context/AppConfigContext";
import { CloudContext } from "../context/CloudContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import UserDashboard from "../components/UserDashboard.jsx"
import Box from '@mui/material/Box';
import SideNavAdmin from '../layout/SideNavAdmin';
import { TopNav } from '../layout/TopNav';
import { styled } from '@mui/material/styles';
import config from '../config.js';
import { useCredentials } from "../hooks/useCredentials";

import NewUserDialog from "../dialog/NewUserDialog.jsx"

const SIDE_NAV_ADMIN_WIDTH = 340;

function Admin() {

    const { 
        user,
        signOut,
        accessToken,
        idToken,
        setJwt
    } = useContext(AuthContext);
    
    const {
        setMaxSpace,
        setMaxFileSize
    } = useContext(AppConfigContext);
    
    // CloudContext setters are now handled by useCredentials hook
    const { getCredentials, retrieveProcessings, processings } = useCredentials();

    const [language, setLanguage] = useState("jp");
    const { i18n } = useTranslation();

    const LayoutAdminRoot = styled('div')(({ theme }) => ({
        display: 'flex',
        flex: '1 1 auto',
        maxWidth: '100%',
        [theme.breakpoints.up('lg')]: {
            paddingLeft: SIDE_NAV_ADMIN_WIDTH
        }
    }));

    const LayoutContainer = styled('div')({
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        width: '100%'
    });

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    useEffect(() => {
        const savedLanguage = localStorage.getItem('languageMirukuru');
        if (savedLanguage) {
            setLanguage(savedLanguage);
            i18n.changeLanguage(savedLanguage);
        }
        if (user) {
                console.log("Admin Mode On");
                retrieveUsers(); // Ensure users are fetched when adminMode is true
        } else {
            console.log("Signout useeffect");
            signOut().then(() => {
                navigate('/login');
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    // processings state is now handled by useCredentials hook

    async function getStrapiUser() {
        let jwtStrapi = "";
        let userStrapi = {};
        try {
            let request = `${config.apiUrl}/api/auth/cognito/callback?id_token=${idToken}&access_token=${accessToken}`;
            let res = await axios.get(request);
            jwtStrapi = res.data.jwt;
            setJwt(jwtStrapi);
            userStrapi = await axios.get(`${config.apiUrl}/api/users/me?populate=*`, {
                headers: {
                    Authorization:
                        `Bearer ${jwtStrapi}`,
                },
            });
            //console.log(countActivitiesCreatedThisMonth(userStrapi.data.activities));
            //setUserAuth(userStrapi.data);
            setMaxSpace(userStrapi.data.space);
            setMaxFileSize(userStrapi.data.maxFileSize);
            getCredentials(jwtStrapi);

            retrieveProcessings(jwtStrapi);

            // Step 3: Update the lastLogin field with the current date and time
            const currentDateTime = new Date().toISOString();  // ISO format
            await axios.put(
                `${config.apiUrl}/api/users/${userStrapi.data.id}`,  // Assumes user ID is in userStrapi.data.id
                { lastLogin: currentDateTime },
                {
                    headers: {
                        Authorization: `Bearer ${jwtStrapi}`,
                    },
                }
            );
            
        } catch {
            console.log("cannot retrieve strapi user");
            signOut().then(res => {
                let path = `/login`;
                navigate(path);
            })
        }
        return {
            jwtStrapi: jwtStrapi,
            userStrapi: userStrapi
        };
    }

    const [users, setUsers] = useState([]);
    const [userSelected, setUserSelected] = useState(null);
    async function retrieveUsers() {
        setLoading(true);
        //console.log("Retrieving users in admin mode..."); // Add this line

        const { jwtStrapi } = await getStrapiUser();
        let res = await axios.get(`${config.apiUrl}/api/users?populate[projects][populate][data][populate][processing_requests][populate]=processing,subprocessings`, {
            headers: {
                Authorization: `Bearer ${jwtStrapi}`,
            },
        });

        let users = res.data;
        users.sort(function (a, b) {
            var textA = a.email.toUpperCase();
            var textB = b.email.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        console.log("Fetched users:", users); // Log the retrieved users
        setUsers(users);

        if (!userSelected) {
            setUserSelected(users[0]);
        } else {
            let newUserSelected = users.find(item => item.id === userSelected.id);
            setUserSelected(newUserSelected);
        }
        setLoading(false);
    }

    // retrieveProcessings and getCredentials are now handled by useCredentials hook
    
    const [openNav, setOpenNav] = useState(false);
    const [openDialogUser, setOpenDialogUser] = useState(false);

    const handleNewUser = () => {
        setOpenDialogUser(true);
        setOpenNav(false);
    };

    const callBackGetUsers = () => {
        retrieveUsers();
    };

    return (
        <div className="Main">
            <>                  
                <TopNav onNavOpen={() => setOpenNav(true)} language={language} setLanguage={setLanguage} projects={[]} users={users} loading={loading} />
                <SideNavAdmin onClose={() => setOpenNav(false)} open={openNav} users={users} userSelected={userSelected} setUserSelected={setUserSelected} handleClickOnNewUser={handleNewUser}/>
                <LayoutAdminRoot>
                    <LayoutContainer>
                        <Box sx={{ flexGrow: 1, margin: 1 }}>
                            {!loading &&<UserDashboard
                                userSelected={userSelected} reloadUsers={callBackGetUsers} processings={processings}
                            />}
                        </Box>
                    </LayoutContainer>
                </LayoutAdminRoot>
                <NewUserDialog open={openDialogUser} setOpen={setOpenDialogUser} handleNewUserCreated={callBackGetUsers} />                   
            </>      
        </div>
    );
}

export default Admin;